import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

function AuthLayout() {
  const navigate = useNavigate();
  const { uid } = useSelector((state: any) => state.user);
  if (uid) {
    navigate("/");
  }
  return <Outlet />;
}

export default AuthLayout;
